import { SignIn } from "@clerk/clerk-react";
import { Sparkles } from "lucide-react";

import { useLocale } from "../lib/i18n";

/**
 * Full-page sign-in surface shown when no Clerk session exists.
 *
 * Replaces the amber "pre-customer demo" banner from M4. Clerk renders
 * the full sign-in flow inline (email + OAuth + magic link, depending
 * on the methods enabled in the Clerk dashboard).
 */
export function SignedOutScreen() {
  const { t } = useLocale();
  return (
    <div className="min-h-screen bg-slate-50 flex flex-col">
      <header className="border-b border-slate-200 bg-white">
        <div className="mx-auto flex max-w-6xl items-center gap-3 px-6 py-4">
          <span className="grid h-9 w-9 place-items-center rounded-lg bg-slate-900 text-white">
            <Sparkles className="h-5 w-5" />
          </span>
          <div className="leading-tight">
            <p className="text-base font-semibold">{t.app_title}</p>
            <p className="text-xs text-slate-500">{t.app_subtitle}</p>
          </div>
        </div>
      </header>
      <main className="flex-1 grid place-items-center px-6 py-12">
        <SignIn
          appearance={{
            elements: {
              rootBox: "shadow-none",
              card: "shadow-md rounded-2xl border border-slate-200",
            },
          }}
          routing="hash"
        />
      </main>
    </div>
  );
}
